import { formatDate } from '@/util/helpers'

export default function () {
  return {
    formatDate,
    message: null,
    profileTypes: {
      teacher: 'Professor(a)',
      student: 'Aluno(a)',
      others: 'Outros',
    },
  }
}
